import { twMerge } from 'tailwind-merge';

import { IGameBanner } from '../constants/games.constants';
import { ROUTES } from 'constants/routes.constant';

import Button from 'components/buttons/Button';

const GameBanner = ({ title, subtitle, text, background, colWidth }: IGameBanner) => {
  return (
    <div
      className="tw-overflow-hidden tw-bg-backgroundColorMedium !tw-bg-[length:0] tw-bg-no-repeat md:tw-h-[250px] md:tw-max-w-screen-md md:tw-rounded-2xl md:!tw-bg-cover md:tw-bg-right lg:tw-h-[360px] lg:tw-max-w-screen-lg lg:tw-p-10 xl:tw-h-[420px] xl:tw-max-w-screen-xl"
      style={{ backgroundImage: `url(${background})` }}
    >
      <img className="tw-w-[150%] [transform:translateX(-33%)] md:!tw-hidden" src={background} alt={title} />
      <div
        className={twMerge(
          'tw-flex tw-w-full tw-flex-col tw-justify-between tw-gap-5 tw-p-5 md:tw-w-[42%] lg:tw-w-1/3 xl:tw-w-[42%]',
          colWidth
        )}
      >
        <div className="tw-flex tw-flex-col tw-gap-5 tw-text-white">
          <h2 className="tw-uppercase lg:tw-text-[32px] xl:tw-text-[44px] 2xl:tw-text-[48px]/[52px]">{title}</h2>
          <p className="tw-font-semibold tw-leading-6 xl:tw-text-[20px] xl:tw-leading-8 2xl:tw-text-[22px]">
            {subtitle}
          </p>
        </div>
        <Button size="medium" twClassName="tw-w-fit" text={text} asLink link={ROUTES.GAMES} target="_self" />
      </div>
    </div>
  );
};

export default GameBanner;
